<template>
  <div>
    <div class="col-md-12">
      <div class="card card-info" v-if="screen==='default'">
        <div class=" card-header with-border">
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">
              Evaluation Name<br />
              <input class="form-control" v-model="EvaluationMaster.EvaluationTitle" />
            </div>
            <div class="col-md-4">
              Valid From
              <br />
              <input class="form-control" type="date" v-model="EvaluationMaster.ValidFrom" />
            </div>
            <div class="col-md-4">
              Valid To<br />
              <input class="form-control" type="date" v-model="EvaluationMaster.ValidTo" />
            </div>

            <div class="col-md-4">
              Semester<br />
              <select class="form-control" v-model="EvaluationMaster.ActiveSemesterID">
                <option v-bind:value="0" disabled="disabled" selected="selected">--Select Semester--</option>
                <option v-for="item in semesters" :value="item.semID">{{item.Name}}</option>
                <!--<%--
                <option value="2">Semester 2</option>
                <option value="3">Semester 3</option>
                <option value="4">Semester 4</option>
                <option value="5">Semester 5</option>
                <option value="6">Semester 6</option>
                <option value="7">Semester 7</option>
                <option value="8">Semester 8</option>--%>-->
              </select>
            </div>
          </div>
        </div>
        <div class="card-footer bg-light ">
          <div class="form-row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xga-12 text-right">
              <button class="btn btn-primary " type="button" v-on:click="next1()">Next</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card card-info" v-if="screen2==='enabled'">
        <div class="card-header with-border">Faculty</div>
        <div class="card-body">
          <div class="col-md-12 table-responsive">
            <table class="table" width="100%">
              <tr>
                <td width="40%">All</td>
                <td width="10%">
                  <input type="checkbox" class="select-checkbox" v-on:change="allfac()" v-model="facstate" />
                </td>
              </tr>
              <tr v-for="(item,index) in fac">
                <td>{{item.Name}}</td>
                <td>
                  <input v-model="item.Post" type="checkbox" />
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="card-footer bg-light ">
          <div class="form-row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xga-12 text-right">
              <button class="btn btn-primary " type="button" v-on:click="next2()">Next</button>
              <button class="btn btn-danger " type="button" v-on:click="previous1()">Previous</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card card-info" v-if="screen3==='enabled'">
        <div class="card-header with-border">Department</div>
        <div class="card-body">
          <div class="col-md-12 table-responsive">
            <table class="table" width="100%">
              <tr>
                <td width="40%">All</td>
                <td width="10%">
                  <input type="checkbox" v-on:change="alldep()" v-model="depstate" />
                </td>
              </tr>
              <tr v-for="(item,index) in dep">
                <td>{{item.Name}}</td>
                <td>
                  <input v-model="item.Post" type="checkbox" />
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="card-footer bg-light ">
          <div class="form-row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xga-12 text-right">
              <button class="btn btn-primary " type="button" v-on:click="next3()">Next</button>
              <button class="btn btn-danger " type="button" v-on:click="previous2()">Previous</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card card-info" v-if="screen4==='enabled'">
        <div class="card-header with-border">Program</div>
        <div class="card-body">
          <div class="col-md-12 table-responsive">
            <table class="table" width="100%">
              <tr>
                <td width="40%">All</td>
                <td width="10%">
                  <input type="checkbox" v-on:change="allprog()" v-model="progstate" />
                </td>
              </tr>
              <tr v-for="(item,index) in prog">
                <td>{{item.Name}}</td>
                <td>
                  <input v-model="item.Post" type="checkbox" />
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="card-footer bg-light ">
          <div class="form-row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xga-12 text-right">
              <button class="btn btn-primary " type="button" v-on:click="next4()">Save</button>
              <button class="btn btn-danger " type="button" v-on:click="previous3()">Previous</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        EvaluationMaster: {
          EvaluationMasterID: 0,
          EvaluationTitle: '',
          ActiveSemesterID: 0,
          ValidTo: '',
          ValidFrom: ''
        },
        semesters: [], screen: 'default', screen2: 'default', fac: [], facID: [], screen3: 'default', dep: [], screen4: 'default', depID: [], prog: [], progID: [],
        facstate: 0,
        depstate: 0,
        progstate: 0, checker: 'default'
      }
    },
    created: function () {
      this.loadsemesters();
    },
    mounted: function () {

    },
    updated: function () {
    },
    methods:
    {
      loadsemesters() {
        startReq();

        var vm = this;
        axios.post('/api/QECApi/loadsemesters')
          .then(function (response) {
            vm.semesters = response.data;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      next1() {
        startReq();
        if (this.EvaluationMaster.ActiveSemesterID == 0 || this.EvaluationMaster.EvaluationTitle == "" || this.EvaluationMaster.ValidFrom == "" || this.EvaluationMaster.ValidTo == "") {
          toastr.error("All fields required");
          endReq();
        }
        else {
          this.screen = "false";
          this.screen2 = "enabled";
          var vm = this;
          axios.post('/api/QECApi/loadfaculties')
            .then(function (response) {
              vm.fac = response.data;
              endReq();
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      },

      previous1() {
        this.screen2 = "default";
        this.screen = "default";
      },

      previous2() {
        this.screen2 = "enabled";
        this.screen3 = "default";
      },

      previous3() {
        this.screen3 = "enabled";
        this.screen4 = "default";
      },

      next2() {
        startReq();
        var vm = this;
        vm.facID = [];
        for (var v in vm.fac) {
          if (vm.fac[v].Post == true) {
            vm.facID.push(vm.fac[v].FacultyID);
          }
        }
        if (vm.facID == "") {
          toastr.error("All fields required");
          endReq();
        }
        else {
          vm.dep = "";
          axios.post('/api/QECApi/getdepartments', {
            FacID: vm.facID
          })
            .then(function (response) {
              vm.dep = response.data;
              endReq();
            })
            .catch(function (error) {
              console.log(error);
            });
          vm.screen3 = "enabled";
          vm.screen2 = "default";
        }

      },

      next3() {
        startReq();
        var vm = this;
        vm.depID = [];
        for (var v in vm.dep) {
          if (vm.dep[v].Post == true) {
            vm.depID.push(vm.dep[v].departmentID);
          }
        }
        if (vm.depID == "") {
          toastr.error("All fields required");
          endReq();
        }
        else {
          vm.prog = "";
          axios.post('/api/QECApi/getprograms', {
            DepID: vm.depID
          })
            .then(function (response) {
              vm.prog = response.data;
              endReq();
            })
            .catch(function (error) {
              console.log(error);
            });

          vm.screen4 = "enabled";
          vm.screen3 = "default";
        }

      },

      next4() {
        startReq();
        var vm = this;
        vm.checker = "default";
        for (var v in vm.prog) {
          if (vm.prog[v].Post == true) {
            vm.checker = "enabled";
            break;
          }
        }
        if (vm.checker == "default") {
          toastr.error("All fields required");
          endReq();
        }
        else {
          axios.post('/api/QECApi/saveEvalutaion', {
            obj: vm.prog,
            obj2: vm.EvaluationMaster
          })
            .then(function (response) {
              endReq();
              window.location = "../QEC/AllEvaluations";
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      },

      allfac() {
        var vm = this;
        if (vm.facstate == true) {
          for (var v in vm.fac) {
            vm.fac[v].Post = true;
          }
        }
        else {
          for (v in vm.fac) {
            vm.fac[v].Post = false;
          }
        }
      },

      alldep() {
        var vm = this;
        if (vm.depstate == true) {
          for (var v in vm.dep) {
            vm.dep[v].Post = true;
          }
        }
        else {
          for (v in vm.dep) {
            vm.dep[v].Post = false;
          }
        }
      },

      allprog() {
        var vm = this;
        if (vm.progstate == true) {
          for (var v in vm.prog) {
            vm.prog[v].Post = true;
          }
        }
        else {
          for (v in vm.prog) {
            vm.prog[v].Post = false;
          }
        }
      },

      cancel() {
        window.location.reload();
      }
    }
  });
</script>
<!--<script>
  function functionx(evt) {
    if (evt.charCode > 31 && (evt.charCode < 48 || evt.charCode > 57)) {
      alert("Allow Only Numbers");
      return false;
    }
  };
</script>-->



// WEBPACK FOOTER //
// src/components/QEC/createevaluation.vue